"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PluginRouter = void 0;

var _urlJoin = _interopRequireDefault(require("url-join")),
    _urlParse = _interopRequireDefault(require("url-parse")),
    _webviewProtocol = require("@daangn/webview-protocol"),
    _createMessage = require("../core/createMessage"),
    _isWebView = require("../core/isWebView"),
    _Base = require("./Base");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var PluginRouter = /*#__PURE__*/function (_Base$PluginBase) {
  _inherits(PluginRouter, _Base$PluginBase);

  var _super = _createSuper(PluginRouter);

  function PluginRouter() {
    var _this;

    _classCallCheck(this, PluginRouter);

    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(a)), _defineProperty(_assertThisInitialized(_this), "namespace", "router");
    return _this;
  }

  _createClass(PluginRouter, [{
    key: "push",
    value: function push(_ref) {
      var a = _ref.remote,
          b = _ref.app,
          c = _ref.path,
          d = _ref.navbar,
          e = _ref.navbarTitle,
          f = _ref.scrollable,
          g = _ref.enableSafeAreaInsets,
          h = _ref.backSwipable;
      if (!(0, _isWebView.isWebView)()) return console.warn("Warn 35506: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
      var i = {};
      if (a) i.remote = c ? (0, _urlJoin.default)(a, "#", c) : a;else if (b && c) {
        var _a = (0, _urlParse.default)(c, !0);

        _a.query._route_from = "push", i.app = b, i.path = _a.pathname + "?" + _urlParse.default.qs.stringify(_a.query);
      }
      i.navbar = d, i.navbarTitle = e, i.scrollable = f, i.enableSafeAreaInsets = g, i.backSwipable = h, this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterPush,
        payload: {
          router: i
        }
      }));
    }
  }, {
    key: "open",
    value: function open(_ref2) {
      var a = _ref2.remote,
          b = _ref2.app,
          c = _ref2.path,
          d = _ref2.navbar,
          e = _ref2.navbarTitle,
          f = _ref2.scrollable,
          g = _ref2.enableSafeAreaInsets,
          h = _ref2.backSwipable;
      if (!(0, _isWebView.isWebView)()) return console.warn("Warn 24015: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
      var i = {};
      if (a) i.remote = c ? (0, _urlJoin.default)(a, "#", c) : a;else if (b && c) {
        var _a2 = (0, _urlParse.default)(c, !0);

        _a2.query._route_from = "open", i.app = b, i.path = _a2.pathname + "?" + _urlParse.default.qs.stringify(_a2.query);
      }
      i.navbar = d, i.navbarTitle = e, i.scrollable = f, i.enableSafeAreaInsets = g, i.backSwipable = h, this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterOpen,
        payload: {
          router: i
        }
      }));
    }
  }, {
    key: "pop",
    value: function pop() {
      return (0, _isWebView.isWebView)() ? void this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterPop
      })) : console.warn("Warn 34741: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
    }
  }, {
    key: "close",
    value: function close() {
      return (0, _isWebView.isWebView)() ? void this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterClose
      })) : console.warn("Warn 33918: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
    }
  }, {
    key: "replace",
    value: function replace(_ref3) {
      var a = _ref3.remote,
          b = _ref3.app,
          c = _ref3.path,
          d = _ref3.navbar,
          e = _ref3.navbarTitle,
          f = _ref3.scrollable,
          g = _ref3.enableSafeAreaInsets,
          h = _ref3.backSwipable;
      if (!(0, _isWebView.isWebView)()) return console.warn("Warn 16295: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
      var i = {};
      if (a) i.remote = c ? (0, _urlJoin.default)(a, "#", c) : a;else if (b && c) {
        var _a3 = (0, _urlParse.default)(c, !0);

        _a3.query._route_from = "open", i.app = b, i.path = _a3.pathname + "?" + _urlParse.default.qs.stringify(_a3.query);
      }
      i.navbar = d, i.navbarTitle = e, i.scrollable = f, i.enableSafeAreaInsets = g, i.backSwipable = h, this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterReplace,
        payload: {
          router: i
        }
      }));
    }
  }, {
    key: "prefetch",
    value: function prefetch(_ref4) {
      var a = _ref4.app;
      return (0, _isWebView.isWebView)() ? void this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterPrefetch,
        payload: {
          router: {
            app: a
          }
        }
      })) : console.warn("Warn 31751: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
    }
  }, {
    key: "style",
    value: function style(_ref5) {
      var a = _ref5.navbar,
          b = _ref5.navbarTitle,
          c = _ref5.scrollable,
          d = _ref5.enableSafeAreaInsets,
          e = _ref5.backSwipable;
      return (0, _isWebView.isWebView)() ? void this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqRouterStyle,
        payload: {
          router: {
            navbar: a,
            navbarTitle: b,
            scrollable: c,
            enableSafeAreaInsets: d,
            backSwipable: e
          }
        }
      })) : console.warn("Warn 11543: WebView \uD658\uACBD\uC774 \uC544\uB2CC \uD658\uACBD\uC5D0\uC11C\uB294 \uD574\uB2F9 \uD568\uC218\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4");
    }
  }]);

  return PluginRouter;
}(_Base.PluginBase);

exports.PluginRouter = PluginRouter;